import React, { useRef } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button } from "antd";

const HorizontalScroller = ({ children, scrollAmount = 200 }) => {
  const containerRef = useRef(null);

  const scrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: -scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        position: "relative",
      }}
    >
      {/* Left Arrow Button */}
      <Button
        type="text"
        icon={<LeftOutlined />}
        onClick={scrollLeft}
        style={{
          border: "1px solid #d9d9d9",
          borderRadius: "50%",
          width: "32px",
          height: "32px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      />

      {/* Scrollable Container */}
      <div
        ref={containerRef}
        style={{
          //   overflowX: "auto",
          overflow: "hidden",
          padding: "4px 0",
          display: "flex",
          gap: "30px",
          flex: 1,
        }}
      >
        {children}
      </div>

      {/* Right Arrow Button */}
      <Button
        type="text"
        icon={<RightOutlined />}
        onClick={scrollRight}
        style={{
          border: "1px solid #d9d9d9",
          borderRadius: "50%",
          width: "32px",
          height: "32px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      />
    </div>
  );
};

export default HorizontalScroller;
